export enum UserAccountLevel {
    DIGITAL = 0,
    PREMIUM = 5000,
    EXCLUSIVE = 250000,
}

export enum UserAccountLevelName {
    EXCLUSIVE = 'Conta Exclusiva',
    PREMIUM = 'Conta Premium',
    DIGITAL = 'Conta Digital',
}
